import { Stack } from "@mui/material";
import { FeedbackFile } from "../../types/apiTypes";
import { useState } from "react";
import { IconButton } from "../ui/IconButton";
import { ChevronLeftIcon } from "../images";

export const ImageSlider = ({
  images,
  imageIndex,
}: {
  images: FeedbackFile[];
  imageIndex: number;
}) => {
  const [currentImageIndex, setCurrentImageIndex] =
    useState<number>(imageIndex);

  const handlePrev = () => {
    const newIndex =
      currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1;
    setCurrentImageIndex(newIndex);
  };

  const handleNext = () => {
    const newIndex =
      currentImageIndex < images.length - 1 ? currentImageIndex + 1 : 0;
    setCurrentImageIndex(newIndex);
  };

  return (
    <Stack gap="16px" width="100%" alignItems="center">
      <Stack
        sx={{
          backgroundColor: "#000000",
          position: "relative",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "648px",
        }}
      >
        <IconButton
          onClick={handlePrev}
          style={{
            position: "absolute",
            left: 8,
            color: "#fff",
            zIndex: 1,
            backgroundColor: "#E5E5E5",
            padding: "0",
            borderRadius: "4px",
            border: "none",
            width: "32px",
            height: "32px",
          }}
          icon={<ChevronLeftIcon color="#4C545B" />}
        />

        <img
          src={images[currentImageIndex].url}
          alt={images[currentImageIndex].filename}
          style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
        />

        <IconButton
          onClick={handleNext}
          style={{
            position: "absolute",
            right: 8,
            color: "#fff",
            zIndex: 1,
            backgroundColor: "#E5E5E5",
            padding: "0",
            borderRadius: "4px",
            border: "none",
            width: "32px",
            height: "32px",
          }}
          icon={<ChevronLeftIcon color="#4C545B" rotate="180" />}
        />
      </Stack>
      <Stack flexDirection="row" gap="4px">
        {Array(images.length)
          .fill(0)
          .map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              style={{
                cursor: index === currentImageIndex ? "auto" : "pointer",
                width: "8px",
                height: "8px",
                backgroundColor:
                  index === currentImageIndex ? "#1976D2" : "#9E9E9E",
                borderRadius: "50%",
              }}
            />
          ))}
      </Stack>
    </Stack>
  );
};
